<template>
  <el-dialog
    :class="classes"
    :visible.sync="isvisible"
    v-bind="$attrs"
    @close="close"
  >
    <div slot="title" class="rt-dialog-title-wrapper">
      <div class="rt-dialog-title">{{ title }}</div>
      <rt-button icon-name="rt-base-close" text icon-size="24" @click="close" />
    </div>
    <div class="rt-dialog-content-wrapper"><slot /></div>
    <div slot="footer" class="rt-dialog-footer-wrapper">
      <div class="rt-dialog-footer-buttons">
        <rt-button @click="cancel">取消</rt-button>
        <rt-button type="primary" @click="confirm">确认</rt-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'RtDialog',
  props: {
    title: String,
    value: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      isvisible: this.value
    };
  },
  computed: {
    classes() {
      return ['rt-dialog-wrapper', `rt-dialog-${this.size}`];
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.isvisible = newVal;
    }
  },
  methods: {
    close() {
      this.isvisible = false;
      this.$emit('input', this.isvisible);
    },
    confirm() {
      this.$emit('confirm');
      this.close();
    },
    cancel() {
      this.$emit('cancel');
      this.close();
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtDialog.vue?fc62d6f0